import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=25fe3baa"
import script from "./LegendItem.vue?vue&type=script&lang=js"
export * from "./LegendItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports